import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import * as _ from 'underscore';
import { ResidentialService } from '../../questionarie-signup/questionnaire-residential/residential.service';
import * as $ from 'jquery';
@Component({
  selector: 'app-plan-history',
  templateUrl: './plan-history.component.html',
  styleUrls: ['./plan-history.component.css'],
})
export class PlanHistoryComponent implements OnInit, AfterViewInit {
  url = environment.api_url;
  selectedAddress;
  enrolledPlan;
  t1_avg_charge;
  t2_avg_charge;
  t3_avg_charge;
  avgMthlyUsage;
  averagePrice;
  avgbill;
  expiredPlan;
  expired_t1_avg_charge;
  expired_t2_avg_charge;
  expired_t3_avg_charge;
  expired_avgMthlyUsage;
  expired_averagePrice;
  expired_avgbill;
  addressModalVisible = false;
  enrolledPlanObj;
  expiredPlanObj;
  selectedAddressList = [];
  hg_accountId;
  enrolledEnable = false;
  expiredEnable = false;
  showSlctAdd = false;
  showViewPlanHis = false;
  ShowAddressbutton = true;
  math = Math;
  chanedAddress;
  selectedESIID;
  expiryChangedAddress;
  selectedAddress1;
  enrollplanObj;
  energyPlanObj;
  currentid = "0";
  queryObj = {
    hg_accountId: null,
  };
  selectedProductLogos = {
    ChariotEnergy: 'Chariot Energy Logo',
    PulsePower: 'Pulse Power Logo',
  };
  showSingleObjDetails: boolean;
  showFilters: boolean;
  openIndex: number;

  constructor(
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService
  ) {}

  ngOnInit() {
    this.hg_accountId = window.location.href.split('/').pop();
    this.selectedAddress = this.residentialService.selectAddress;
    const body = new HttpParams();
    body.append('selectedAddress', this.selectedAddress);
    body.append('hg_accountId', this.hg_accountId);
    this.http
      .get(this.url + '/getPlanHistory', { params: body })
      .subscribe((res: any) => {
        if (res && res.statusCode && res.statusCode === '0010') {
          this.router.navigateByUrl('/login');
        } else {
          this.setSelectedAddress(res);
          this.selectedAddress = JSON.stringify(this.selectedAddress);
          this.getPlanHistoryDetails();
        }
      });
  }

  setSelectedAddress(resAddress) {
    if (resAddress.addressList && resAddress.addressList.length > 0) {
      this.selectedAddress =
        resAddress.addressList[0].billingAddress.userAddress;
      this.selectedAddress1 =
        resAddress.addressList[0].billingAddress.userAddress;
    }
  }
  getPlanHistoryDetails() {
    const selectedAddressObj = new HttpParams()
      .append('selectedAddress', this.selectedAddress)
      .append('hg_accountId', this.hg_accountId);
    this.http
      .get(this.url + '/getPlanHistory', { params: selectedAddressObj })
      .subscribe((slctAddressPlan: any) => {
        const result = slctAddressPlan;
        if (result.addressList && result.addressList.length > 1) {
          this.showSlctAdd = true;
        } else {
          this.showSlctAdd = false;
        }
        this.setEnrolledPlanObj(result);
        if (
          !_.isEmpty(this.enrolledPlanObj) ||
          this.enrolledPlanObj !== undefined
        ) {

          sessionStorage.setItem(
            'IsHaveEnrollPlans',
            "true"
          );

          this.selectedAddress = this.enrolledPlanObj.billingAddress
            ? this.enrolledPlanObj.billingAddress.userAddress
            : null;
          this.enrolledEnable = true;
          this.chanedAddress =
            this.selectedAddress.street_address +
            ', ' +
            this.selectedAddress.city +
            ', ' +
            this.selectedAddress.state +
            ', ' +
            this.selectedAddress.zipcode;

            var localquestions =  sessionStorage.getItem(
              'ShowAnotherAddress'
            );

            if(localquestions == "false")
            {
              this.ShowAddressbutton = false;
            }


        } else {
          this.enrolledEnable = false;
        }
        console.log('enable..', this.enrolledEnable);
        // Expired plan
        this.expiredPlanObj = result.expired_plan;
        if (!_.isEmpty(this.expiredPlanObj) || this.expiredPlanObj !== null) {
          this.selectedAddress = this.expiredPlanObj.billingAddress
            ? this.expiredPlanObj.billingAddress.userAddress
            : null;
          this.expiredPlanObj.billingAddress.userAddress = JSON.stringify(
            this.selectedAddress
          );
          this.expiryChangedAddress =
            this.selectedAddress.street_address +
            ',' +
            ' ' +
            this.selectedAddress.city +
            ',' +
            ' ' +
            this.selectedAddress.state +
            ',' +
            ' ' +
            this.selectedAddress.zipcode;

          this.expiredEnable = true;
          this.expiredPlan = result.expired_plan.selectedProduct;
          this.expired_t1_avg_charge = (
            Number(this.expiredPlan.tier[0].avg_charge) * 100
          ).toFixed(1);
          this.expired_t2_avg_charge = (
            Number(this.expiredPlan.tier[1].avg_charge) * 100
          ).toFixed(1);
          this.expired_t3_avg_charge = (
            Number(this.expiredPlan.tier[2].avg_charge) * 100
          ).toFixed(1);
          this.expired_avgMthlyUsage = Math.round(
            this.expiredPlan.new_tier.ave_monthly_usage
          );
          this.expired_averagePrice =
            Number(this.expiredPlan.new_tier.ave_price_per_KWH) * 100;
          this.expired_avgbill =
            this.expiredPlan.new_tier.ave_monthly_bill.toFixed(1);
        } else {
          this.expiredEnable = false;
        }
        this.selectedAddressList = _.uniq(
          result.addressList,
          function (address) {
            let newad = address.billingAddress.billingAddress.billingAddress;
            return (address.billingAddress.userAddress1 =
              newad.street_address +
              ',' +
              (address.billingAddress.apartment == "" ? "" : address.billingAddress.apartment + ", ") 
              +
              newad.city +
              ',' +
              newad.state +
              ',' +
              newad.zipcode);
          }
        );

      

      });
  }

  setEnrolledPlanObj(result) {
    if (
      result.enrolled_plan &&
      result.enrolled_plan[0].isDepositRequired != 'Required Deposite Fields'
    ) {
      this.enrolledPlanObj = result.enrolled_plan[0];
      this.enrollplanObj = result.enrolled_plan;
    }
  }

  ngAfterViewInit() {
    const body = new HttpParams();
    this.selectedAddress = JSON.stringify(this.selectedAddress);
    body.append('selectedAddress', this.selectedAddress);
    body.append('hg_accountId', this.hg_accountId);
    this.http
      .get(this.url + '/getSelectedPlanHistory', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (result.length > 1) {
          this.showViewPlanHis = true;
        } else {
          this.showViewPlanHis = false;
        }
      });
    setTimeout(() => {
      // Enrolled plan
      const avgElements = document.getElementsByClassName('avgvalue');
      for (let i = 0; i < avgElements.length; i++) {
        if (avgElements[i].classList.contains('avgvalue')) {
          if (this.averagePrice || this.avgbill) {
            if (this.averagePrice.length >= 9 || this.avgbill.length >= 9) {
              avgElements[i].classList.add('avgpricelen28');
            } else if (
              this.averagePrice.length === 8 ||
              this.avgbill.length === 8
            ) {
              avgElements[i].classList.add('avgpricelen31');
            } else if (
              this.averagePrice.length === 7 ||
              this.avgbill.length === 7
            ) {
              avgElements[i].classList.add('avgpricelen37');
            } else if (
              this.averagePrice.length === 6 ||
              this.avgbill.length === 6
            ) {
              avgElements[i].classList.add('avgpricelen43');
            } else if (
              this.averagePrice.length <= 5 ||
              this.avgbill.length <= 5
            ) {
              avgElements[i].classList.add('avgpricelen48');
            }
          }
        }
      }
      // Expired plan
      const expAvgElements = document.getElementsByClassName('expavgvalue');
      for (let i = 0; i < expAvgElements.length; i++) {
        if (expAvgElements[i].classList.contains('expavgvalue')) {
          if (this.expired_averagePrice || this.expired_avgbill) {
            if (
              this.expired_averagePrice.length >= 9 ||
              this.expired_avgbill.length >= 9
            ) {
              expAvgElements[i].classList.add('avgpricelen28');
            } else if (
              this.expired_averagePrice.length === 8 ||
              this.expired_avgbill.length === 8
            ) {
              expAvgElements[i].classList.add('avgpricelen31');
            } else if (
              this.expired_averagePrice.length === 7 ||
              this.expired_avgbill.length === 7
            ) {
              expAvgElements[i].classList.add('avgpricelen37');
            } else if (
              this.expired_averagePrice.length === 6 ||
              this.expired_avgbill.length === 6
            ) {
              expAvgElements[i].classList.add('avgpricelen43');
            } else if (
              this.expired_averagePrice.length <= 5 ||
              this.expired_avgbill.length <= 5
            ) {
              expAvgElements[i].classList.add('avgpricelen48');
            }
          }
        }
      }
    }, 1);
  }
  showAddressModal() {
    this.addressModalVisible = true;
    this.residentialService.setSelectedAddress(this.selectedAddress);
  }
  getAddress(event,essid) {
    this.selectedAddress = event;

    this.chanedAddress =
      this.selectedAddress.street_address +
      ',' +
      this.selectedAddress.city +
      ',' +
      this.selectedAddress.state +
      ',' +
      this.selectedAddress.zipcode;


      this.selectedESIID = essid;
  }
  submit() {
    this.addressModalVisible = false;
    $('.modal-backdrop').css('display', 'none');
    $('body').css('padding-right', '0');
    const body = new HttpParams();
    this.residentialService.selectAddress = this.selectedAddress;
    this.residentialService.selectESIID = this.selectedESIID;
    this.router.navigate([
      'user-settings/plan-history-details',
      this.hg_accountId,
    ]);
  }
  viewPastPlans() {
    this.residentialService.setSelectedAddress(this.selectedAddress);
    this.router.navigate([
      'user-settings/plan-history-details',
      this.hg_accountId,
    ]);
  }

  // To redirect questionnarie page
  redirectQuestionnarie() {
    // getting the username to save in localstorage for add another address flow.
    const userName = localStorage.getItem('userName');
    const userObj = sessionStorage.getItem('userObj');
    sessionStorage.clear();
    sessionStorage.setItem('userObj', userObj);
    this.residentialService.messageService({});
    this.residentialService.userResponse.userResponses = [];
    localStorage.setItem('userName', userName);
    this.residentialService.questionFlowType = 'add-address';
    this.router.navigateByUrl('/residentialQues');
  }

  selectedProductLogo(singleObj) {
    return this.selectedProductLogos[
      singleObj.selectedProduct.energy_provider.replace(/\s/g, '')
    ];
  }

  showSingleObjFilterCard(id) {
    this.showSingleObjDetails = !this.showSingleObjDetails;
    this.showFilters = false;
    this.currentid = id;
  }

  isDate(date) {
   
  return Date.parse(date).toString() == "NaN" ? false : true
  
  
  }

  SelectAddressfunction(e)
  {
    $("#" + e).trigger('click')
  }


  addanotheraddress() {
    //alert("jjjjj");
    if (
      !_.isEmpty(sessionStorage.getItem('userObj')) &&
      _.isEmpty(sessionStorage.getItem('postresult'))
    ) {
      const currentUser = JSON.parse(sessionStorage.getItem('userObj'));
      var hg_accountId = currentUser.hg_accountId
        ? currentUser.hg_accountId
        : currentUser._id;

      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }

      const body = new HttpParams().append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;

      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (
              result.user.questionStatusObj != null &&
              result.user.questionStatusObj.questionStatus != 'Completed' &&
              result.userResponses &&
              result.userResponses.length > 0
            ) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;
                  sessionStorage.removeItem('questionStatusObj');
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  console.log(sessionStorage.getItem('userResponse'));
                  this.residentialService.messageService({});
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              this.residentialService.userResponse.userResponses = [];
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      if (
        this.residentialService.questionnaireStatusObj &&
        this.residentialService.questionnaireStatusObj.questionStatus ===
          'Quitted'
      ) {
        this.residentialService.questionnaireStatusObj.questionStep = '000';
        this.residentialService.userResponse.userResponses = null;
      }
      this.residentialService.userResponse.userResponses = [];
      if (
        this.residentialService.userResponse.userResponses != null &&
        this.residentialService.userResponse.userResponses.length > 0
      ) {
        sessionStorage.clear();
        this.router.navigateByUrl('/residentialQues');
        this.residentialService.messageService({
          currentId: null,
          questionStatus: null,
        });
        // }
      } else {
        if (!sessionStorage.getItem('Promocode')) {
          sessionStorage.clear();
        }
        this.residentialService.messageService({});
        this.router.navigateByUrl('/residentialQues');
      }
    }
  }
}
